import "./MyFocus.css";
const MyFocus = () => {
  return (
    <div className="my-focus col-12 col-md-6">
      <h3>My Focus</h3>
      <hr />
      <ul className="list-without-dots">
        <li>Mongo db</li>
        <li>Express.js</li>
        <li>Anguler</li>
        <li>React</li>
        <li>Node.js</li>
      </ul>
    </div>
  );
};
export default MyFocus;
